// Navbar.js
import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import NetCert from '../../images/NetworkPlus Logo Certified CE White.png';
import SecCert from '../../images/SecurityPlus Logo Certified CE White.png';
import logo from '../../images/Portfolio Logo V2.png';

import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLogo,
  CertLogo,
  NavMenu,
  NavBtn,
  NavBtnLink
} from './NavbarElements';

const Navbar = () => {
  const [scrollNav, setScrollNav] = useState(false);
  const [showMobileMenu, toggle] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const openInNewTab = () => {
    window.open("https://www.credly.com/users/kobe-cox");
  };

  const openTHMaccount = () => {
    window.open("https://tryhackme.com/r/p/KCX");
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo onClick={toggleHome} to='/'>
              <img src={logo} style={{ position: 'relative', left: 150, height: 250, paddingRight: 675 }} />
            </NavLogo>
            <MobileIcon onClick={() => toggle(!showMobileMenu)}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
              <NavItem style={{ position: 'relative', right: 200 }}>
                <NavLinks to='about' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  About
                </NavLinks>
              </NavItem>
              <NavItem style={{ position: 'relative', right: 200 }}>
                <NavLinks to='services' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Projects
                </NavLinks>
              </NavItem>
              <NavItem style={{ position: 'relative', right: 200 }}>
                <NavLinks to='contact' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Contact
                </NavLinks>
              </NavItem>
            </NavMenu>
          </NavbarContainer>

          {/* Desktop Cert Logos */}
          <CertLogo onClick={openInNewTab} to='/'>
            <img src={NetCert} style={{ position: 'relative', height: 75 }} />
          </CertLogo>
          <CertLogo onClick={openInNewTab} to='/'>
            <img src={SecCert} style={{ position: 'relative', height: 75 }} />
          </CertLogo>
          <CertLogo onClick={openTHMaccount} to='/'>
            <img src="https://tryhackme-badges.s3.amazonaws.com/KCX.png" alt="Your Image Badge" style={{ position: 'relative', height: 75 }} />
          </CertLogo>
        </Nav>

        {/* Mobile Dropdown */}
        {showMobileMenu && (
          <div style={{
            backgroundColor: '#000',
            position: 'absolute',
            top: '80px',
            width: '100%',
            zIndex: '1000',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '1rem 0',
          }}>
            <NavLinks to='about' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
              About
            </NavLinks>
            <NavLinks to='services' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
              Projects
            </NavLinks>
            <NavLinks to='contact' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
              Contact
            </NavLinks>
            <div style={{ marginTop: '1rem' }}>
              <img src={NetCert} onClick={openInNewTab} alt="Network+" style={{ height: 50, margin: '0.5rem' }} />
              <img src={SecCert} onClick={openInNewTab} alt="Security+" style={{ height: 50, margin: '0.5rem' }} />
              <img src="https://tryhackme-badges.s3.amazonaws.com/KCX.png" onClick={openTHMaccount} alt="THM" style={{ height: 50, margin: '0.5rem' }} />
            </div>
          </div>
        )}
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
